import { render, staticRenderFns } from "./flyerEditor.vue?vue&type=template&id=5a64cea2&"
import script from "./flyerEditor.vue?vue&type=script&lang=js&"
export * from "./flyerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports